define( function() {
	"use strict";

	// [[Class]] -> type pairs
	return {};
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/class2type.js
// module id = 37
// module chunks = 0